<template lang="pug">
div.row
    div.col-xs-12
        div.row
            div.col-xs-6
                div.box.p-a.text-center
                    div.clear
                        div.text-muted Total Cash In
                        h4.m-a-0.text-md._600
                            a(v-if="! onLoading('fetch-summary')") {{ getFormattedCurrency(summary.total_cash_in) }}
                            v-loading(loader="fetch-summary")

            div.col-xs-6
                div.box.p-a.text-center
                    div.clear
                        div.text-muted Total Cash Out
                        h4.m-a-0.text-md._600
                            a(v-if="! onLoading('fetch-summary')") {{ getFormattedCurrency(summary.total_cash_out) }}
                            v-loading(loader="fetch-summary")
    div.col-xs-12
        div.box
            cash-adjustment-list
</template>

<script>
import cashAdjustmentList from './cash-adjustment-list.vue';
import reportFilterMixins from '../../../mixins/report-filter';
import formattedCurrencyMixins from '../../../mixins/formatted-currency';
import { mapGetters } from 'vuex';

export default {
    components: { cashAdjustmentList },
    mixins: [reportFilterMixins, formattedCurrencyMixins],

    data() {
        return {
            summary: {
                total_cash_in: null,
                total_cash_out: null,
            },
        };
    },

    mounted() {
        this.getCashAdjustmentSummary();
        this.registerReportFilterEvent();
    },

    methods: {
        getCashAdjustmentSummary() {
            this.startLoading('fetch-summary');
            let url = Laroute.route(
                'franchise.report.cash_adjustments.summary',
            );
            url += `?${this.filterParams}`;

            axios
                .get(url)
                .then(res => {
                    this.summary = res.data;
                    this.endLoading('fetch-summary');
                })
                .catch(err => {
                    this.showApiError(err);
                    this.endLoading('fetch-summary');
                });
        },

        registerReportFilterEvent() {
            this.$on('outlet-changed', val => {
                this.getCashAdjustmentSummary();
            });

            this.$on('date-changed', val => {
                this.getCashAdjustmentSummary();
            });
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/report/cash-adjustment/cash-adjustment.vue